
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	Button,
	Col,
	FormGroup,
	Input,
	Label,
	Row
} from 'reactstrap'

const filterListStyle = {
	border: '1px solid #ced4da',
	borderRadius: '0.25rem',
	maxHeight: '120px',
	overflowY: 'auto',
	backgroundColor: '#fff'
}

const filterItemStyle = (isSelected) => ({
	padding: '0.25rem 0.75rem',
	cursor: 'pointer',
	backgroundColor: isSelected ? '#cfe2ff' : 'transparent',
	fontWeight: isSelected ? '600' : 'normal',
	userSelect: 'none',
	borderBottom: '1px solid #f0f0f0',
	fontSize: '0.875rem'
})

const SearchAuctions = (props ) =>
{
	const { t } = useTranslation()

	return (
		<>
			<Row>
				<Col md="3">
					<FormGroup>
						<Label htmlFor="makes">
							{ t('Auctions.Search.Make') }
						</Label>
						<div style={filterListStyle}>
							{
								(props.viewModel.makes || []).map((make, idx) =>
								{
									const isSelected = (props.searchRequest.makes || []).includes(make)
									return (
										<div
											key={idx}
											style={filterItemStyle(isSelected)}
											onClick={() => props.handleMakesChange(make)}
										>
											{ make }
										</div>
									)
								})
							}
						</div>
					</FormGroup>
				</Col>
				<Col md="3">
					<FormGroup>
						<Label htmlFor="models">
							{ t('Auctions.Search.Models') }
						</Label>
						<div style={filterListStyle}>
							{
								(props.viewModel.models || []).map((model, idx) =>
								{
									const isSelected = (props.searchRequest.models || []).includes(model)
									return (
										<div
											key={idx}
											style={filterItemStyle(isSelected)}
											onClick={() => props.handleModelsChange(model)}
										>
											{ model }
										</div>
									)
								})
							}
						</div>
					</FormGroup>
				</Col>
				<Col md="3">
					<FormGroup>
						<Label htmlFor="provinces">
							{ t('Auctions.Search.Province') }
						</Label>
						<div style={filterListStyle}>
							{
								(props.viewModel.provinces || []).map((province, idx) =>
								{
									const isSelected = (props.searchRequest.provinces || []).includes(province.code)
									return (
										<div
											key={idx}
											style={filterItemStyle(isSelected)}
											onClick={() => props.handleProvincesChange(province.code)}
										>
											{ province.name }
										</div>
									)
								})
							}
						</div>
					</FormGroup>
				</Col>
				<Col md="3">
					<FormGroup>
						<Label htmlFor="serialNumber">
							{ t('Vehicles.Search.Vin') }
						</Label>
						<Input
							name="serialNumber"
							type="text"
							value={ props.searchRequest.serialNumber }
							onChange={ props.handleSearchParameterChange }
						/>
					</FormGroup>
				</Col>
			</Row>
			<Row>
				<Col md="3">
					<Row>
						<Col md="12">
							<Label htmlFor="yearRange">
								{ t('Auctions.Search.Year') }
							</Label>
						</Col>
					</Row>
					<Row>
						<Col md="5">
							<FormGroup>
								<Input
									name="yearFrom"
									type="text"
									value={ props.searchRequest.yearFrom }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
						<Col md="2">
							<FormGroup><Label>{ t('Auctions.Search.To') }</Label></FormGroup>
						</Col>
						<Col md="5">
							<FormGroup>
								<Input
									name="yearTo"
									type="text"
									value={ props.searchRequest.yearTo }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
					</Row>
				</Col>
				<Col md="3">
					<Row>
						<Col md="12">
							<Label htmlFor="priceRange">
								{ t('Auctions.Search.Price') }
							</Label>
						</Col>
					</Row>
					<Row>
						<Col md="5">
							<FormGroup>
								<Input
									name="priceFrom"
									type="text"
									value={ props.searchRequest.priceFrom }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
						<Col md="2">
							<FormGroup><Label>{ t('Auctions.Search.To') }</Label></FormGroup>
						</Col>
						<Col md="5">
							<FormGroup>
								<Input
									name="priceTo"
									type="text"
									value={ props.searchRequest.priceTo }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
					</Row>
				</Col>
				<Col md="3">
					<Row>
						<Col md="12">
							<Label htmlFor="odometerRange">
								{ t('Auctions.Search.Odometer') }
							</Label>
						</Col>
					</Row>
					<Row>
						<Col md="5">
							<FormGroup>
								<Input
									name="odometerFrom"
									type="text"
									value={ props.searchRequest.odometerFrom }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
						<Col md="2">
							<FormGroup><Label>{ t('Auctions.Search.To') }</Label></FormGroup>
						</Col>
						<Col md="5">
							<FormGroup>
								<Input
									name="odometerTo"
									type="text"
									value={ props.searchRequest.odometerTo }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
					</Row>
				</Col>
				<Col md="3">
					<FormGroup>
						<Label htmlFor="trim">
							{ t('Auctions.Search.Trim') }
						</Label>
						<Input
							name="trim"
							type="text"
							value={ props.searchRequest.trim }
							onChange={ props.handleSearchParameterChange }
							placeholder="Enter trim..."
						/>
					</FormGroup>
				</Col>
			</Row>
			<Row>
				<Col md="3">
					<Row>
						<Col md="12">
							<Label htmlFor="daysInInventoryRange">
								{ t('Auctions.Search.DaysInInventory') }
							</Label>
						</Col>
					</Row>
					<Row>
						<Col md="5">
							<FormGroup>
								<Input
									name="daysInInventoryFrom"
									type="text"
									value={ props.searchRequest.daysInInventoryFrom }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
						<Col md="2">
							<FormGroup><Label>{ t('Auctions.Search.To') }</Label></FormGroup>
						</Col>
						<Col md="5">
							<FormGroup>
								<Input
									name="daysInInventoryTo"
									type="text"
									value={ props.searchRequest.daysInInventoryTo }
									onChange={ props.handleSearchParameterChange }
								/>
							</FormGroup>
						</Col>
					</Row>
				</Col>
				<Col md="3"></Col>
				<Col md="3"></Col>
				<Col md="3"></Col>
			</Row>
			<Row><Col md="12"></Col></Row>
			<Row>
				<Col md="12">
					<Button
						block
						color="primary"
						className="btn-block"
						size="lg"
						onClick={ props.handleSearchAuctions }
					>
						{ t('Auctions.Search.Search_Auctions') }
					</Button>
				</Col>
			</Row>
		</>
	)
}

export default SearchAuctions
